module.exports = __webpack_public_path__ + "static/work54-9c258d5b59fd2ea6d20fcf33e788534c.jpg";